/**
 * 
 * @param {number} digit 
 * @param {number} length 
 * @param {number} additionalSymbol 
 * @returns {string}
 */
export function padstartDigit(digit, length = 2, additionalSymbol = 0) {
    return String(digit).padStart(length, additionalSymbol)
}